import React from "react";
import styles from "../Dashboard.module.css";

const Communications = () => {
  return (
    <div className={styles.dashboard}>
      <main className={styles.main}>Communications</main>
    </div>
  );
};

export default Communications;
